<form [formGroup]="form">
  <div id="information-recruit-add2">
    <div class="recruit-add1">
      <table>
      <colgroup>
        <col style="width:14%">
        <col style="width:36%">
        <col style="width:14%">
        <col style="width:36%">
      </colgroup>

      <tbody>
      <tr>
        <th><i class="material-icons cred f11">star</i> 제목</th>
        <td colspan="3">
          <input type="text" id="subject" formControlName="subject" [ngClass]="{formErrors:formErrors['subject']}" [ngModel]="board.subject" autofocus="true" />
        </td>
      </tr>
      <tr class="tr-ul">
        <td colspan="4" class="td-ul">
          <ul>
            <li>
              <p class="th">전공</p>
              <p class="td"><input type="text" id="speciality" formControlName="speciality" [ngClass]="{formErrors:formErrors['speciality']}" [ngModel]="board.speciality" /></p>
            </li>
            <li>
              <p class="th">급여</p>
              <p class="td">
                <select id="salary_seq" formControlName="salary_seq" [ngModel]="board.salary_seq">
                  <option *ngFor="let item of salary" [ngValue]="item.seq">{{item.common_name}}</option>
                </select>
              </p>
            </li>
            <li>
              <p class="th">이름</p>
              <p class="td"><input type="text" id="name" formControlName="name" [ngClass]="{formErrors:formErrors['name']}" [ngModel]="board.name" /></p>
            </li>
            <li>
              <p class="th">생일</p>
              <p class="td birthdate">
                <select id="is_solar" formControlName="is_solar" [ngClass]="{formErrors:formErrors['is_solar']}" [ngModel]="board.is_solar">
                  <option value="1">양력</option>
                  <option value="0">음력</option>
                </select>
                <input type="text" id="birthday" formControlName="birthday" [ngClass]="{formErrors:formErrors['birthday']}" [ngModel]="board.birthday" placeholder="(ex) 19751117" />
              </p>
            </li>
            <li>
              <p class="th"><i class="material-icons cred f11">star</i> 희망업무</p>
              <p class="td">
                <select id="recuritment_part_seq" formControlName="recuritment_part_seq" [ngModel]="board.recuritment_part_seq" [ngClass]="{formErrors: formErrors['recuritment_part_seq'] != ''}">
                  <option *ngFor="let item of recuritmentPart" [ngValue]="item.seq">{{item.common_name}}</option>
                </select>
              </p>
            </li>
            <li>
              <p class="th"><i class="material-icons cred f11">star</i> 학력</p>
              <p class="td">
                <select id="academic_ability_seq" formControlName="academic_ability_seq" [ngModel]="board.academic_ability_seq">
                  <option *ngFor="let item of academicAbility" [ngValue]="item.seq">{{item.common_name}}</option>
                </select>
              </p>
            </li>
            <li>
              <p class="th">이메일</p>
              <p class="td"><input type="text" id="contact_email" formControlName="contact_email" [ngClass]="{formErrors:formErrors['contact_email']}" [ngModel]="board.contact_email" /></p>
            </li>
            <li>
              <p class="th">연락처</p>
              <p class="td">
                <input type="text" class="w60 mr10" id="tel1" formControlName="tel1" [ngModel]="board.tel1"/>
                -<input type="text" class="w60 ml10 mr10" id="tel2" formControlName="tel2" [ngModel]="board.tel2" />
                -<input type="text" class="w60 ml10" id="tel3" formControlName="tel3" [ngModel]="board.tel3" />
                <span *ngIf="formErrors['tel1'] || formErrors['tel2'] || formErrors['tel3']">{{ formErrors['tel1'] ? formErrors['tel1'] : ( formErrors['tel2'] ? formErrors['tel2'] : ( formErrors['tel3'] ? formErrors['tel3'] : '' ) ) }}</span>
              </p>
            </li>
            <li>
              <p class="th">홈페이지</p>
              <p class="td"><input type="text" id="website" formControlName="website" [ngClass]="{formErrors:formErrors['website']}" [ngModel]="board.website" /></p>
            </li>
            <li>
              <p class="th"><i class="material-icons cred f11">star</i> 경력구분</p>
              <p class="td">
                <select id="career_seq" formControlName="career_seq" [ngModel]="board.career_seq">
                  <option *ngFor="let item of career" [ngValue]="item.seq">{{item.common_name}}</option>
                </select>
              </p>
            </li>
          </ul>
        </td>
      </tr>
      <tr>
        <th>주 소</th>
        <td colspan="3">
          <div class="zipcode">
            <input type="text" id="zipcode" formControlName="zipcode" [ngClass]="{formErrors:formErrors['zipcode']}" [ngModel]="board.zipcode" readonly />
            <btn-daum-address (result)="setDaumAddressApi($event)" [options]="daumAddressOptions"></btn-daum-address>
            <span *ngIf="formErrors['zipcode']">{{formErrors['zipcode']}}</span>
          </div>
          <input type="text" class="addr1" id="address" formControlName="address" [ngClass]="{formErrors:formErrors['address']}" [ngModel]="board.address" readonly />
          <input type="text" class="addr2" placeholder="나머지 주소를 입력해 주세요." id="address_detail" formControlName="address_detail" [ngClass]="{formErrors:formErrors['address_detail']}" [ngModel]="board.address_detail" />
        </td>
      </tr>
      <tr>
        <th><i class="material-icons cred f11">star</i> 내 용</th>
        <td colspan="3">
          <textarea class="contents" id="contents" formControlName="contents" [ngClass]="{formErrors:formErrors['contents']}" [ngModel]="board.contents"></textarea>
        </td>
      </tr>
      </tbody>
      </table>

      <div class="btn-area">
        <button class="add-btn" (click)="write()">등록</button>
        <button class="list-btn" (click)="list()">취소</button>
      </div>
    </div>
  </div>
</form>
